// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__2G5DC","watch_detail":"Modal_watch_detail__3IbJp","sort":"Modal_sort__3ALkH","cost_td_block":"Modal_cost_td_block__1xuqc","content":"Modal_content__4cO-9"};